module.exports = __webpack_public_path__ + "static/media/grayHandRaise.46cbdc66.svg";